import * as React from 'react';

import { IStyledComponent } from 'styled-components';

import { ReactFCC } from '@notino/react-styleguide';

import {
  ImageCircle,
  ImageCircleWrapper,
  ItemContent,
  ItemContainer,
} from './styled';

type IItemProps = React.HTMLAttributes<HTMLButtonElement> &
  React.ComponentProps<IStyledComponent<'web', Record<string, unknown>>> & {
    background?: string;
    imageUrl: string;
    labelledby?: string;
    smallerImage?: boolean;
  };

export const Item: ReactFCC<IItemProps> = ({
  children,
  background,
  imageUrl,
  labelledby,
  smallerImage,
  ...rest
}) => {
  return (
    <ItemContainer>
      <ImageCircleWrapper {...rest} background={background}>
        <ImageCircle
          src={imageUrl}
          smaller={smallerImage}
          aria-labelledby={labelledby}
        />
      </ImageCircleWrapper>

      <ItemContent>{children}</ItemContent>
    </ItemContainer>
  );
};
